//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

export const PATH = 'salesByCategory'
export const OPEN_SALES_BY_CATEGORY_REPORT = `${PATH}/OPEN_SALES_BY_CATEGORY_REPORT `
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
